<div class="container-fluid d-flex align-items-center justify-content-center min-vh-100 bg-light">
    <div class="col-md-6 col-lg-4">
      <div class="text-center mb-4">
        <img src="../../../assets/logo-sigvaris-group.jpg" alt="Sigvaris Group Logo" class="img-fluid mb-3" style="max-width: 200px; height: 120px;">
      </div>
      <div class="card custom-card">
        <div class="card-body" style="padding-left: 25px; padding-right: 25px;">
          <h2 class="card-title text-center mb-3 mt-4" style="font-weight: bold;">Reset Password</h2>
          <p class="text-center mb-4">We'll email you instructions on how to reset your password.</p>
          <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
            <div class="mb-3">
              <label for="email" class="form-label">Email of User</label>
              <input type="email" class="form-control" id="email" formControlName="email" placeholder="Placeholder text">
            </div>
            <button type="submit" class="mt-4 mb-4 j7 j8 an j9 ja ft fu bn fj fk fv fw fl fm am e8 b3 e6 bt bu jb jc ju je q r s ds bw cv by cx c2" style="width: 100%;height: 50px;">Request new Password</button>
          </form>
        </div>
      </div>
    </div>
  </div>